var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-upload',{attrs:{"showUploadList":false,"customRequest":this.$method.import_upload},on:{"change":function($event){return _vm.import_upload_change($event,_vm.url)}}},[_c('a-button',{staticClass:"a_btn"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }